import type { Messages } from "../catalogue.en";

export const finance: Partial<Messages> = {
  "finance.priceList.loading": "Загрузка прайс-листа",
  "finance.priceList.forbidden": "Вам не разрешено читать прайс-лист клиники.",
  "finance.priceList.actions": "Действия",
  "finance.priceLists.subtitle": "Именованные списки цен клиники; цена услуги попадает в основной прайс-лист.",
  "finance.priceLists.tableLabel": "Прайс-листы",
  "finance.priceLists.column.name": "Прайс-лист",
  "finance.priceLists.column.default": "Основной",
  "finance.priceLists.column.branches": "Филиалы",
  "finance.priceLists.column.state": "Состояние",
  "finance.priceLists.defaultBadge": "Основной прайс-лист",
  "finance.priceLists.wholeClinic": "Вся клиника",
  "finance.priceLists.active": "Действует",
  "finance.priceLists.archived": "В архиве",
  "finance.priceLists.openNamed": "Настройки: {name}",
  "finance.priceLists.makeDefaultNamed": "Сделать {name} основным прайс-листом",
  "finance.priceLists.madeDefault": "{name} теперь основной прайс-лист.",
  "finance.priceLists.loadFailed": "Не удалось загрузить прайс-листы.",
  "finance.priceLists.empty": "Прайс-листов нет",
  "finance.priceLists.emptyDetail": "Добавьте прайс-лист или запишите первую цену услуги в разделе «Услуги»: основной прайс-лист клиники появится вместе с ней.",
  "finance.priceLists.emptyDetailReader": "Ни один прайс-лист ещё не создан.",
  "finance.priceLists.readOnly": "Вам доступно чтение прайс-листов; для изменений нужно право управления прайс-листами.",
  "finance.priceList.title": "Прайс-лист",
  "finance.priceList.new": "Новый прайс-лист",
  "finance.priceList.name": "Название",
  "finance.priceList.branches": "Филиалы",
  "finance.priceList.branchesHint": "Ни один филиал не отмечен: прайс-лист действует для всей клиники.",
  "finance.priceList.isDefault": "Основной прайс-лист",
  "finance.priceList.isDefaultHint": "Цена новой услуги попадает сюда, и цена без указания прайс-листа читается отсюда.",
  "finance.priceList.isDefaultLocked": "Основной прайс-лист остаётся основным, пока его место не займёт другой.",
  "finance.priceList.firstIsDefault": "Первый прайс-лист клиники становится основным.",
  "finance.priceList.save": "Сохранить",
  "finance.priceList.active": "Действует",
  "finance.priceList.archived": "В архиве",
  "finance.priceList.archive": "В архив",
  "finance.priceList.archiveTitle": "Отправить прайс-лист в архив?",
  "finance.priceList.archiveDescription": "Прайс-лист перестанет назначать цены новым работам. Цены, уже закреплённые в документах, не изменятся.",
  "finance.priceList.archiveConfirm": "Архивировать прайс-лист",
  "finance.priceList.keepList": "Оставить прайс-лист",
  "finance.priceList.archiveLocked": "Прежде чем архивировать, назначьте основным другой прайс-лист.",
  "finance.priceList.archiveDirty": "Сохраните или отмените изменения, прежде чем архивировать.",
  "finance.priceList.archivedNote": "Прайс-лист в архиве: его цены сохраняются для документов, которые их закрепили, и не меняются.",
  "finance.priceList.unsaved": "Несохранённый прайс-лист",
  "finance.priceList.discard": "Отменить изменения",
  "finance.priceList.reloadDiscard": "Перезагрузить, отменив изменения",
  "finance.priceList.saveFailed": "Не удалось сохранить прайс-лист.",
  "finance.priceList.changed": "Прайс-лист изменился с момента открытия. Перезагрузите его перед сохранением.",
  "finance.priceList.invalid": "Прайс-лист отклонён. Проверьте название и филиалы.",
  "finance.priceList.notFound": "Этого прайс-листа больше нет.",
  "finance.priceList.archivedRefusal": "Прайс-лист в архиве и не может меняться.",
  "finance.priceList.defaultRequired": "Сначала назначьте основным другой прайс-лист: основной нельзя архивировать или разжаловать.",
  "finance.priceList.loadFailed": "Не удалось загрузить прайс-лист.",
  "finance.priceList.pricesLoadFailed": "Не удалось загрузить цены.",
  "finance.priceList.edit": "Изменить прайс-лист",
  "finance.priceList.tabs": "Разделы прайс-листа",
  "finance.priceList.pricesTab": "Цены",
  "finance.priceList.packagesTab": "Наборы",
  "finance.priceList.onDate": "Цены на дату",
  "finance.priceList.branch": "Для филиала",
  "finance.priceList.servicesLabel": "Услуги в прайс-листе {name}",
  "finance.priceList.column.service": "Услуга",
  "finance.priceList.column.price": "Цена",
  "finance.priceList.column.tax": "Налог",
  "finance.priceList.column.from": "С",
  "finance.priceList.column.until": "До",
  "finance.priceList.column.scope": "Область",
  "finance.priceList.column.state": "Состояние услуги",
  "finance.priceList.setPriceNamed": "Назначить цену: {name}",
  "finance.priceList.openPriceNamed": "Цены: {name}",
  "finance.priceList.servicesEmpty": "Услуг нет",
  "finance.priceList.servicesEmptyDetail": "Создайте услуги в разделе «Услуги» — они появятся здесь для назначения цен.",
  "finance.priceRow.title": "Цена",
  "finance.priceRow.inList": "В прайс-листе {list}",
  "finance.priceRow.current": "На {date}: {price}, {scope}",
  "finance.priceRow.currentNone": "Нет цены на {date}",
  "finance.priceRow.amount": "Новая цена, {currency}",
  "finance.priceRow.amountRequired": "Укажите цену.",
  "finance.priceRow.scope": "Действует для",
  "finance.priceRow.from": "С даты",
  "finance.priceRow.fromRequired": "Укажите первый день действия цены.",
  "finance.priceRow.until": "До даты, необязательно",
  "finance.priceRow.untilHint": "Первый день, когда цена уже не действует; пусто — цена бессрочная.",
  "finance.priceRow.untilInvalid": "Дата окончания должна быть позже даты начала.",
  "finance.priceRow.save": "Записать цену",
  "finance.priceRow.discard": "Отменить",
  "finance.priceRow.unsaved": "Незаписанная цена",
  "finance.priceRow.serviceArchived": "Услуга в архиве: её цены сохраняются, новую записать нельзя.",
  "finance.priceRow.saveFailed": "Не удалось записать цену.",
  "finance.priceRow.invalid": "Цена отклонена. Проверьте сумму и даты.",
  "finance.pricePackage.title": "Набор",
  "finance.pricePackage.new": "Новый набор",
  "finance.pricePackage.name": "Название",
  "finance.pricePackage.lines": "Услуги в наборе",
  "finance.pricePackage.service": "Услуга",
  "finance.pricePackage.chooseService": "Выберите услугу",
  "finance.pricePackage.quantity": "Количество",
  "finance.pricePackage.addLine": "Добавить услугу",
  "finance.pricePackage.allAdded": "Все оценённые услуги прайс-листа уже в наборе.",
  "finance.pricePackage.removeLine": "Убрать строку {position}",
  "finance.pricePackage.linesRequired": "Укажите хотя бы одну оценённую услугу и её количество.",
  "finance.pricePackage.nonePriced": "В этом прайс-листе ещё нет оценённых услуг; набор включает только оценённые услуги.",
  "finance.pricePackage.save": "Записать набор",
  "finance.pricePackage.discard": "Отменить",
  "finance.pricePackage.unsaved": "Незаписанный набор",
  "finance.pricePackage.saveFailed": "Не удалось записать набор.",
  "finance.pricePackage.invalid": "Набор отклонён. Проверьте даты, услуги и корректировки.",
  "finance.pricePackage.tableLabel": "Наборы прайс-листа {name}",
  "finance.pricePackage.column.name": "Набор",
  "finance.pricePackage.column.lines": "Услуги",
  "finance.pricePackage.column.state": "Состояние",
  "finance.pricePackage.line": "{name} × {quantity}",
  "finance.pricePackage.empty": "Наборов нет",
  "finance.pricePackage.emptyDetail": "Набор объединяет оценённые услуги прайс-листа для покупки по предоплате.",
  "finance.pricePackage.retractNamed": "Отозвать {name}",
  "finance.pricePackage.retractTitle": "Отозвать набор?",
  "finance.pricePackage.retractDescription": "{name} больше не будет предлагаться. Уже совершённые покупки сохранят свои основания.",
  "finance.pricePackage.retractConfirm": "Отозвать",
  "finance.pricePackage.keep": "Оставить набор",
  "finance.pricePackage.retractFailed": "Не удалось отозвать набор.",

  "finance.services.title": "Оказанные услуги",
  "finance.services.subtitle":
    "Услуги, подтверждённые для этого документа ЭМК, и их зафиксированные начисления.",
  "finance.services.loading": "Загрузка оказанных услуг",
  "finance.services.loadFailed": "Не удалось загрузить оказанные услуги.",
  "finance.services.tableLabel": "Оказанные услуги для этого документа ЭМК",
  "finance.services.empty": "Услуги не записаны",
  "finance.services.emptyDetail":
    "Здесь появятся подтверждённые услуги этой записи.",
  "finance.services.noMatches": "Нет услуг, соответствующих этим фильтрам",
  "finance.services.noMatchesDetail":
    "Расширьте или очистите фильтры столбцов, чтобы вернуться ко всем оказанным услугам.",
  "finance.services.column.service": "Услуга",
  "finance.services.column.code": "Код",
  "finance.services.column.quantity": "Количество",
  "finance.services.column.charge": "Начисление",
  "finance.services.column.performed": "Записано",
  "finance.services.column.serviceDate": "Дата услуги",
  "finance.serviceCorrection.action": "Исправить: {name}",
  "finance.serviceCorrection.title": "Исправление оказанной услуги",
  "finance.serviceCorrection.units": "Исходные единицы для сторнирования",
  "finance.serviceCorrection.unit": "Единица {number}",
  "finance.serviceCorrection.correctedUnit": "Единица {number} (уже сторнирована)",
  "finance.serviceCorrection.reason": "Причина",
  "finance.serviceCorrection.remaining": "Количество после исправления",
  "finance.serviceCorrection.postingDate": "Дата проводки исправления",
  "finance.serviceCorrection.portion": "Обязательство {number}",
  "finance.serviceCorrection.credit": "Уменьшение обязательства",
  "finance.serviceCorrection.release": "Необходимо освободить из оплаты",
  "finance.serviceCorrection.payment": "Освободить из оплаты от {date}",
  "finance.serviceCorrection.available": "Доступно для освобождения: {amount}",
  "finance.serviceCorrection.noPayout": "Возврат денежных средств не оформляется.",
  "finance.serviceCorrection.preview": "Проверить исправление",
  "finance.serviceCorrection.loading": "Загрузка расчёта…",
  "finance.serviceCorrection.confirm": "Подтвердить исправление",
  "finance.serviceCorrection.saving": "Сохранение исправления…",
  "finance.serviceCorrection.chooseUnits": "Выберите исходные единицы для сторнирования.",
  "finance.serviceCorrection.releaseRequired": "Для каждого обязательства укажите точную сумму освобождения из перечисленных оплат.",
  "finance.serviceCorrection.reasonRequired": "Укажите причину длиной не менее трёх символов.",
  "finance.serviceCorrection.failed": "Не удалось сохранить исправление. Введённые данные сохранены.",
  "finance.serviceCorrection.periodClosed": "Период проводки закрыт. Откройте его перед сохранением исправления.",
  "finance.serviceCorrection.provenanceRequired": "Исходные сведения о покрытии не позволяют выполнить это частичное сторнирование.",
  "finance.serviceCorrection.sourceChanged": "Услуга или её финансовое состояние изменились. Обновите данные перед повторной попыткой.",
  "finance.serviceCorrection.forbidden": "Нужны права на финансовые исправления и изменение клинических записей.",
  "finance.serviceCorrection.unsaved": "В исправлении услуги остались несохранённые выбранные единицы и причина.",
  "finance.serviceCorrection.reload": "Обновить услугу",
  "finance.serviceCorrection.reloadFailed": "Не удалось обновить услугу. Введённые данные сохранены.",
  "finance.serviceCorrection.reloaded": "Услуга обновлена. Заново выберите оставшиеся исходные единицы.",
  "finance.services.priceUnavailable":
    "Не удалось загрузить текущий прайс-лист.",

  "finance.encounterServices.title": "Услуги",
  "finance.encounterServices.subtitle":
    "Оказанные услуги для этой записи ЭМК и их записанные начисления.",
  "finance.encounterServices.forbidden":
    "У вас нет прав на просмотр услуг этой записи ЭМК.",
  "finance.encounterServices.loading": "Загрузка услуг записи ЭМК",
  "finance.encounterServices.loadFailed":
    "Не удалось загрузить услуги записи ЭМК.",
  "finance.encounterServices.tableLabel":
    "Оказанные услуги для этой записи ЭМК",
  "finance.encounterServices.emptyDetail":
    "Выберите услугу в прайс-листе рядом с таблицей — она запишется с количеством 1.",
  "finance.encounterServices.emptyNoRecordsDetail":
    "Сохраните документ ЭМК, прежде чем записывать услугу.",
  "finance.encounterServices.emptyNoPrimaryRecordDetail":
    "Услуга начисляется на текущий основной документ записи, а у этой записи его нет.",
  "finance.encounterServices.noPrimaryRecord":
    "У этой записи ЭМК нет текущего основного документа, на который можно начислить услугу.",
  "finance.encounterServices.column.record": "Документ ЭМК",
  "finance.encounterServices.recordName": "{document}, {authored}",
  "finance.encounterServices.billedOn": "Начислено на {name}",
  "finance.encounterServices.recordUnavailable": "Недоступная запись",
  "finance.encounterServices.column.actions": "Действия",

  "finance.servicePicker.title": "Медицинские услуги",
  "finance.servicePicker.catalogueTab": "Прайс-лист",
  "finance.servicePicker.searchPlaceholder": "Название или код услуги",
  "finance.servicePicker.loading": "Загрузка прайс-листа",
  "finance.servicePicker.empty": "В прайс-листе нет услуг.",
  "finance.servicePicker.noMatches": "Нет услуг, соответствующих этому поиску.",

  "finance.patient.title": "Финансы",
  "finance.patient.forbidden":
    "Вам не разрешено читать финансовую карту этого пациента.",
  "finance.patient.forbiddenDetail":
    "Остальная часть карты пациента по-прежнему доступна.",
  "finance.menuLabel": "Разделы финансов",
  "finance.nav.estimates": "Сметы",
  "finance.nav.estimatesDescription": "Сметы стоимости лечения пациента",
  "finance.evidence.original": "Исходная выставленная сумма",

  "finance.correction.reason": "Причина исправления",
  "finance.correction.reasonRequired":
    "Укажите конкретную причину исправления.",
  "finance.correction.stale":
    "Финансовое подтверждение изменилось. Закройте и снова откройте окно, чтобы проверить последнюю редакцию.",
  "finance.correction.historicalIncomplete":
    "Эта историческая запись не содержит полного неизменяемого снимка, поэтому её нельзя безопасно исправить.",
  "finance.correction.unsavedIntent": "Несохранённое финансовое исправление",

  // ——— Финансовое рабочее место: /finance ———
  "finance.workspace.title": "Финансы",
  "finance.workspace.tileDescription": "Счета, поступления, услуги и цены, закрытие месяца",
  "finance.workspace.areaNavigation": "Разделы финансов",
  "finance.nav.accounts": "Расчётные счета",
  "finance.nav.accountsDescription": "Балансы и принятые деньги",
  "finance.nav.people": "Участники расчётов",
  "finance.nav.peopleDescription": "Персоны и организации, участвующие в расчётах",
  "finance.nav.priceLists": "Прайс-листы",
  "finance.nav.priceListsDescription": "Цены клиники на услуги по датам",
  "finance.nav.taxes": "Налоги",
  "finance.nav.taxesDescription": "Налоговые условия по датам, которые может включать цена",
  "finance.nav.externalCosts": "Внешние расходы",
  "finance.nav.externalCostsDescription": "Справочник сторонних расходов для смет лечения",
  "finance.nav.administration": "Настройки финансов",
  "finance.nav.administrationDescription": "Финансовый профиль и месячные периоды",
  "finance.nav.services": "Услуги",
  "finance.nav.servicesDescription": "Что делает клиника и сколько это стоит сегодня",
  "finance.clinicServices.subtitle": "Все услуги клиники и их цены на сегодня",
  "finance.clinicServices.tableLabel": "Услуги клиники",
  "finance.clinicServices.column.name": "Услуга",
  "finance.clinicServices.column.source": "Источник",
  "finance.clinicServices.column.price": "Цена сегодня",
  "finance.clinicServices.column.state": "Состояние",
  "finance.clinicServices.actions": "Действия",
  "finance.clinicServices.openNamed": "Открыть {name}",
  "finance.clinicServices.priceByBranch": "Зависит от филиала",
  "finance.clinicServices.readOnly": "Вы можете читать услуги и их цены, но не менять их.",
  "finance.clinicServices.loading": "Загрузка услуг",
  "finance.clinicServices.loadFailed": "Не удалось загрузить услуги.",
  "finance.clinicServices.empty": "Услуг пока нет",
  "finance.clinicServices.emptyDetail": "Добавьте первую услугу клиники. Цена необязательна.",
  "finance.clinicServices.emptyDetailReader": "Ни одна услуга клиники ещё не названа.",
  "finance.clinicServices.noDefaultList": "Цены не показаны: у клиники несколько прайс-листов и ни один не основной. Выберите основной в разделе «Прайс-листы».",
  "finance.clinicService.title": "Услуга клиники",
  "finance.clinicService.new": "Новая услуга",
  "finance.clinicService.source": "Источник услуги",
  "finance.clinicService.custom": "Названа клиникой",
  "finance.clinicService.terminology": "Из справочника медицинских услуг",
  "finance.clinicService.search": "Поиск по справочнику медицинских услуг",
  "finance.clinicService.conceptRequired": "Выберите услугу из справочника.",
  "finance.clinicService.conceptClear": "Очистить выбранную услугу",
  "finance.clinicService.name": "Название услуги",
  "finance.clinicService.save": "Сохранить",
  "finance.clinicService.price": "Цена, {currency}",
  "finance.clinicService.newPrice": "Новая цена с сегодняшнего дня, {currency}",
  "finance.clinicService.priceOptional": "Для всех филиалов, с сегодняшнего дня. Оставьте пустым, чтобы сохранить без цены; цена для филиала или на период задаётся в разделе «Прайс-листы».",
  "finance.clinicService.priceInvalid": "Введите цену цифрами, не больше {scale} знаков после десятичного разделителя клиники.",
  "finance.clinicService.priceList": "Прайс-лист",
  "finance.clinicService.priceListDefault": "{list} — основной",
  "finance.clinicService.priceListEvery": "Во все прайс-листы",
  "finance.clinicService.priceListHint": "Цена попадёт в этот прайс-лист. «Во все прайс-листы» запишет ту же цену в каждый из них.",
  "finance.clinicService.priceInList": "Цена попадёт в прайс-лист {list}.",
  "finance.clinicService.priceFirstList": "У клиники ещё нет прайс-листа: эта цена создаст основной.",
  "finance.clinicService.priceListFailed": "Цена не записана в прайс-лист {list}.",
  "finance.clinicService.tax": "Налог",
  "finance.clinicService.noTax": "Без налога",
  "finance.clinicService.history": "Цены",
  "finance.clinicService.historyLoading": "Загрузка цен",
  "finance.clinicService.historyLoadFailed": "Не удалось загрузить цены.",
  "finance.clinicService.historyEmpty": "Цена ещё не задана.",
  "finance.clinicService.pricesInList": "Цены услуги {name} в прайс-листе {list}",
  "finance.clinicService.pastPricesInList": "Прошлые цены услуги {name} в прайс-листе {list}",
  "finance.clinicService.pastPrices": "Прошлые цены",
  "finance.clinicService.noCurrentPrices": "Сегодня ни одна цена не действует.",
  "finance.clinicService.priceSince": "С {from}",
  "finance.clinicService.priceBetween": "С {from} до {until}",
  "finance.clinicService.allBranches": "Все филиалы",
  "finance.clinicService.rowLive": "Действует",
  "finance.clinicService.rowFuture": "Предстоит",
  "finance.clinicService.rowEnded": "Завершена",
  "finance.clinicService.rowRetracted": "Отозвана",
  "finance.clinicService.retractNamed": "Отозвать цену {price} с {from}",
  "finance.clinicService.retractTitle": "Отозвать эту цену?",
  "finance.clinicService.retractDescription": "Цена {price} с {from} будет считаться никогда не заданной; цены, которые она заменила, снова действуют. Выставленные сметы сохраняют цену на дату выставления.",
  "finance.clinicService.retractConfirm": "Отозвать",
  "finance.clinicService.keepPrice": "Оставить цену",
  "finance.clinicService.active": "Активна",
  "finance.clinicService.archived": "В архиве",
  "finance.clinicService.archive": "В архив",
  "finance.clinicService.restore": "Восстановить",
  "finance.clinicService.unsavedName": "несохранённое название услуги",
  "finance.clinicService.unsaved": "несохранённая услуга клиники",
  "finance.clinicService.unsavedPrice": "несохранённая цена услуги",
  "finance.clinicService.discard": "Отменить изменения",
  "finance.clinicService.reloadDiscard": "Перезагрузить и отменить изменения",
  "finance.clinicService.saveFailed": "Не удалось сохранить услугу.",
  "finance.clinicService.codeConflict": "Услуга с таким кодом уже существует.",
  "finance.clinicService.revisionConflict": "Услуга клиники изменилась, пока вы её редактировали. Перезагрузите перед сохранением.",
  "finance.clinicService.suggestionStale": "Подсказки были сделаны для прежнего названия. Запросите их снова.",
  "finance.clinicService.notFound": "Этой услуги больше нет.",
  "finance.clinicService.archivedRefusal": "Архивную услугу нельзя менять. Сначала восстановите её.",
  "finance.clinicService.invalid": "Услуга отклонена. Проверьте название и цену.",
  "finance.clinicService.dictionaryFailed": "Не удалось загрузить справочник услуг.",
  "finance.clinicService.dictionaryUnavailable": "Справочник услуг клиники не отвечает. Проверьте привязки терминологии клиники.",
  "finance.clinicService.changed": "Услуга или её цены тем временем изменились. Перезагрузите перед сохранением.",
  "finance.clinicService.listArchived": "Основной прайс-лист в архиве. Восстановите его или выберите другой основной в разделе «Прайс-листы».",
  "finance.clinicService.listUnavailable": "У клиники несколько прайс-листов и ни один не основной. Выберите основной в разделе «Прайс-листы».",
  "finance.clinicService.priceNotFound": "Этой цены больше нет. Перезагрузите.",
  "finance.clinicService.priceRetracted": "Эта цена уже отозвана.",

  "finance.party.loading": "Имя загружается",
  "finance.party.unavailable": "Имя недоступно",
  "finance.party.peopleGroup": "Люди",
  "finance.party.entitiesGroup": "Юридические лица",

  "finance.accounts.title": "Расчётные счета",
  "finance.accounts.tableLabel": "Расчётные счета",
  "finance.accounts.columnOwner": "Владелец",
  "finance.accounts.columnLifecycle": "Состояние",
  "finance.accounts.columnCurrency": "Валюта",
  "finance.accounts.columnCreated": "Открыт",
  "finance.accounts.lifecycleActive": "Действует",
  "finance.accounts.lifecycleArchived": "В архиве",
  "finance.accounts.lifecycleClosed": "Закрыт",
  "finance.accounts.loading": "Загрузка расчётных счетов",
  "finance.accounts.empty": "Расчётных счетов пока нет",
  "finance.accounts.emptyDetail": "Первый счёт открывается кнопкой выше.",
  "finance.accounts.noMatches": "Нет подходящих счетов",
  "finance.accounts.noMatchesDetail":
    "Измените или снимите ограничение, чтобы увидеть больше счетов.",
  "finance.accounts.ownerFilter": "Сузить по владельцу",
  "finance.accounts.ownerAny": "Любой владелец",
  "finance.accounts.ownerNarrowed": "Владелец: {name}",
  "finance.accounts.ownerNarrowedClear": "Показать всех владельцев",
  "finance.accounts.createTitle": "Открыть расчётный счёт",
  "finance.accounts.createDetail":
    "Один счёт на владельца, в валюте, закреплённой финансовым профилем.",
  "finance.accounts.createSubmit": "Открыть счёт",
  "finance.accounts.createSubmitting": "Открывается",
  "finance.accounts.ownerField": "Владелец",
  "finance.accounts.ownerPlaceholder": "Поиск людей и юридических лиц",
  "finance.accounts.ownerRequired": "Выберите владельца счёта.",
  "finance.accounts.createUnsaved": "неоткрытый расчётный счёт",
  "finance.accounts.createUnsavedDetail": "Выбранный владелец будет отброшен.",
  "finance.accounts.failed": "Не удалось выполнить операцию с расчётным счётом.",
  "finance.accounts.exists":
    "У этой стороны уже есть расчётный счёт. Откройте существующий счёт.",
  "finance.accounts.conflict":
    "Счёт изменился, пока вы работали. Перечитайте его и повторите.",
  "finance.accounts.stateConflict": "Состояние счёта не допускает это действие.",
  "finance.accounts.profileUnconfigured":
    "Финансовый профиль ещё не настроен. Сначала настройте его в разделе администрирования финансов.",
  "finance.accounts.attemptConflict":
    "Эта попытка уже была отправлена с другими данными. Закройте форму и начните заново.",
  "finance.accounts.forbidden": "У вас нет права на это действие с расчётным счётом.",
  "finance.accounts.invalid": "Проверьте введённые данные.",

  "finance.account.title": "Расчётный счёт",
  "finance.account.loading": "Загрузка счёта",
  "finance.account.loadFailed": "Не удалось загрузить счёт.",
  "finance.account.factsLabel": "Сведения о счёте",
  "finance.account.changeLifecycle": "Изменить состояние",
  "finance.account.positionTitle": "Позиция",
  "finance.account.positionLoading": "Расчёт позиции",
  "finance.account.positionFailed": "Не удалось рассчитать позицию.",
  "finance.account.positionAsOf": "На {date}",
  "finance.account.bucketReceivable": "К получению",
  "finance.account.bucketPendingConfirmation": "Ожидает подтверждения",
  "finance.account.bucketDisputed": "Оспаривается",
  "finance.account.bucketAvailableFunds": "Доступные средства",
  "finance.account.bucketPrepaidValue": "Предоплаченная ценность",
  "finance.account.lifecycleTitle": "Изменить состояние счёта",
  "finance.account.lifecycleDetail": "Укажите новое состояние счёта и причину.",
  "finance.account.lifecycleField": "Новое состояние",
  "finance.account.lifecycleSubmit": "Изменить состояние",
  "finance.account.lifecycleSubmitting": "Изменяется",
  "finance.account.lifecycleUnsaved": "неотправленное изменение состояния",
  "finance.account.reasonField": "Причина",
  "finance.account.reasonRequired": "Укажите причину.",

  "finance.receipts.title": "Поступления",
  "finance.receipts.tableLabel": "Поступления",
  "finance.receipts.record": "Записать поступление",
  "finance.receipts.columnCashDate": "Дата приёма",
  "finance.receipts.columnRemitter": "Плательщик",
  "finance.receipts.columnMethod": "Способ",
  "finance.receipts.columnAmount": "Сумма",
  "finance.receipts.columnAvailable": "Доступно",
  "finance.receipts.columnRecorded": "Записано",
  "finance.receipts.loading": "Загрузка поступлений",
  "finance.receipts.loadFailed": "Не удалось загрузить поступления.",
  "finance.receipts.empty": "Поступлений пока нет",
  "finance.receipts.emptyDetail": "Принятые на этот счёт деньги появятся здесь.",
  "finance.receipts.methodCash": "Наличные",
  "finance.receipts.methodCard": "Карта",
  "finance.receipts.methodBankTransfer": "Банковский перевод",
  "finance.receipts.methodOther": "Иное",
  "finance.receipts.recordTitle": "Записать поступление",
  "finance.receipts.recordDetail":
    "Деньги, принятые на этот счёт, ровно как они были приняты.",
  "finance.receipts.recordSubmit": "Записать поступление",
  "finance.receipts.recordSubmitting": "Записывается",
  "finance.receipts.remitterField": "Плательщик",
  "finance.receipts.remitterPlaceholder": "Поиск людей и юридических лиц",
  "finance.receipts.remitterRequired": "Выберите, кто внёс деньги.",
  "finance.receipts.amountField": "Сумма",
  "finance.receipts.amountRequired": "Введите принятую сумму.",
  "finance.receipts.methodField": "Способ",
  "finance.receipts.branchField": "Принимающий филиал",
  "finance.receipts.branchRequired": "Выберите принимающий филиал.",
  "finance.receipts.branchesFailed": "Не удалось загрузить филиалы.",
  "finance.receipts.cashDateField": "Дата приёма",
  "finance.receipts.evidenceField": "Ссылка на подтверждение",
  "finance.receipts.evidenceRequired":
    "Назовите подтверждение поступления — квитанцию, перевод или кассовую ссылку.",
  "finance.receipts.reasonField": "Причина",
  "finance.receipts.reasonRequired": "Укажите причину.",
  "finance.receipts.unsavedIntent": "незаписанное поступление",
  "finance.receipts.unsavedDetail": "Введённое поступление будет отброшено.",
  "finance.receipts.reload": "Перечитать счёт",
  "finance.receipts.reloadFailed": "Не удалось перечитать счёт.",
  "finance.receipts.reloaded":
    "Счёт перечитан. Проверьте черновик и отправьте его.",
  "finance.receipts.digestTitle": "Поступление",
  "finance.receipts.postingDate": "Дата проводки",
  "finance.receipts.journalTransaction": "Журнальная транзакция",
  "finance.receipts.evidenceDigest": "Отпечаток подтверждения",
  "finance.receipts.beneficiaryRestricted":
    "Ограничено нуждами одного пациента.",
  "finance.receipts.failed": "Не удалось записать поступление.",
  "finance.receipts.conflict":
    "Счёт изменился, пока вы работали. Перечитайте его и отправьте поступление снова.",
  "finance.receipts.accountStateConflict":
    "Поступления записываются только на действующий счёт.",
  "finance.receipts.periodClosed":
    "Финансовый период этой даты приёма закрыт. Откройте его заново в администрировании финансов или выберите другую дату.",
  "finance.receipts.amountInvalid":
    "Не удалось разобрать сумму. Введите её в числовом формате клиники.",
  "finance.receipts.amountOverflow": "Сумма слишком велика.",
  "finance.receipts.currencyMismatch": "Валюта суммы не совпадает с валютой счёта.",
  "finance.receipts.attemptConflict":
    "Эта попытка уже была отправлена с другими данными. Закройте форму и начните заново.",
  "finance.receipts.forbidden": "У вас нет права записывать поступления.",
  "finance.receipts.invalid": "Проверьте введённые данные поступления.",

  "finance.people.title": "Участники расчётов",
  "finance.people.tableLabel": "Участники расчётов",
  "finance.people.loading": "Загрузка участников расчётов",
  "finance.people.empty": "Участников расчётов пока нет",
  "finance.people.emptyDetail":
    "Добавьте существующую персону или организацию либо зарегистрируйте новую.",
  "finance.people.noMatches": "Нет подходящих людей",
  "finance.people.noMatchesDetail": "Измените поиск, чтобы увидеть больше людей.",
  "finance.people.registerTitle": "Зарегистрировать финансовое лицо",
  "finance.people.registerDetail":
    "Человек, владеющий счетами или вносящий деньги, названный на своём языке.",
  "finance.people.registerSubmit": "Зарегистрировать",
  "finance.people.registerSubmitting": "Регистрируется",
  "finance.people.registerUnsaved": "незарегистрированное финансовое лицо",
  "finance.people.registerUnsavedDetail": "Введённые имена будут отброшены.",
  "finance.people.reasonField": "Причина",
  "finance.people.reasonRequired": "Укажите причину.",
  "finance.people.languageField": "Основной язык",
  "finance.people.participationTitle": "Участие",
  "finance.people.participationFailed": "Не удалось загрузить участие.",
  "finance.people.participationUnsaved": "неотправленное изменение участия",
  "finance.people.active": "Участвует",
  "finance.people.withdrawn": "Выведен",
  "finance.people.withdraw": "Вывести",
  "finance.people.reinstate": "Вернуть",
  "finance.people.namesTitle": "Имена",
  "finance.people.namesLoading": "Загрузка имён",
  "finance.people.namesFailed": "Не удалось загрузить имена.",
  "finance.people.namesUnsaved": "несохранённые изменения имён",
  "finance.people.reload": "Перечитать",
  "finance.people.reloadFailed": "Не удалось перечитать.",
  "finance.people.reloaded": "Перечитано. Проверьте черновик и сохраните.",
  "finance.people.failed": "Не удалось выполнить операцию с финансовым лицом.",
  "finance.people.conflict":
    "Запись этого человека изменилась, пока вы работали. Перечитайте её и повторите.",
  "finance.people.attemptConflict":
    "Эта попытка уже была отправлена с другими данными. Закройте форму и начните заново.",
  "finance.people.forbidden": "У вас нет права на это действие с финансовыми лицами.",
  "finance.people.invalid": "Проверьте введённые данные.",

  "finance.administration.title": "Настройки финансов",
  "finance.administration.profileTitle": "Финансовый профиль",
  "finance.administration.profileLoading": "Загрузка профиля",
  "finance.administration.profileLoadFailed": "Не удалось загрузить профиль.",
  "finance.administration.unconfigured":
    "Финансовый профиль не настроен. Пока он не настроен, нельзя открыть счёт и записать деньги.",
  "finance.administration.unconfiguredDetail":
    "Для настройки нужно право управления профилем.",
  "finance.administration.configure": "Настроить профиль",
  "finance.administration.configureTitle": "Настроить финансовый профиль",
  "finance.administration.configureDetail":
    "Валюта клиники и день, с которого она действует.",
  "finance.administration.configureSubmit": "Настроить",
  "finance.administration.configureSubmitting": "Настраивается",
  "finance.administration.configureUnsaved": "неотправленная настройка профиля",
  "finance.administration.configureUnsavedDetail":
    "Введённая настройка будет отброшена.",
  "finance.administration.currency": "Валюта",
  "finance.administration.currencyField": "Валюта",
  "finance.administration.currencyRequired": "Выберите валюту.",
  "finance.administration.currenciesFailed": "Не удалось загрузить каталог валют.",
  "finance.administration.effectiveFrom": "Действует с",
  "finance.administration.effectiveFromField": "Действует с",
  "finance.administration.effectiveFromRequired":
    "Выберите день, с которого профиль действует.",
  "finance.administration.reasonField": "Причина",
  "finance.administration.reasonRequired": "Укажите причину.",
  "finance.administration.operatingEntity": "Операционное юридическое лицо",
  "finance.administration.recordedAt": "Записан",
  "finance.administration.reload": "Перечитать",
  "finance.administration.reloadFailed": "Не удалось перечитать.",
  "finance.administration.reloaded":
    "Перечитано. Проверьте состояние и повторите.",
  "finance.administration.profileFailed": "Не удалось сохранить профиль.",
  "finance.administration.profileUnconfigured": "На эту дату профиль не настроен.",
  "finance.administration.profileConflict":
    "Профиль изменился, пока вы настраивали. Перечитайте его и проверьте действующую редакцию.",
  "finance.administration.currencyLocked":
    "Валюта клиники уже закреплена записанными деньгами и не может измениться.",
  "finance.administration.attemptConflict":
    "Эта попытка уже была отправлена с другими данными. Закройте форму и начните заново.",
  "finance.administration.profileForbidden":
    "У вас нет права управлять финансовым профилем.",
  "finance.administration.profileInvalid": "Проверьте введённую настройку.",
  "finance.administration.periodsTitle": "Финансовые периоды",
  "finance.administration.monthField": "Месяц",
  "finance.administration.periodLoading": "Загрузка периода",
  "finance.administration.periodLoadFailed": "Не удалось загрузить период.",
  "finance.administration.open":
    "Месяц открыт — в него можно записывать деньги.",
  "finance.administration.closed":
    "Месяц закрыт — записывать в него деньги нельзя.",
  "finance.administration.changedAt": "Последнее изменение {time}.",
  "finance.administration.closePeriod": "Закрыть месяц",
  "finance.administration.reopenPeriod": "Открыть месяц заново",
  "finance.administration.periodUnsaved": "неотправленное изменение периода",
  "finance.administration.periodFailed": "Не удалось изменить период.",
  "finance.administration.periodConflict":
    "Период изменился, пока вы работали. Перечитайте его и повторите.",
  "finance.administration.periodStateConflict": "Период уже в этом состоянии.",
  "finance.administration.periodForbidden":
    "У вас нет права закрывать и открывать периоды.",
  "finance.administration.periodInvalid": "Проверьте введённые данные.",
  "finance.serviceEntry.date": "Дата оказания услуги",
  "finance.serviceEntry.postingDate": "Дата проводки",
  "finance.serviceEntry.list": "Прайс-лист",
  "finance.serviceEntry.chooseList": "Выберите прайс-лист",
  "finance.serviceEntry.account": "Расчётный счёт",
  "finance.serviceEntry.chooseAccount": "Выберите расчётный счёт",
  "finance.serviceEntry.accountMissing": "Для этого пациента нет активного расчётного счёта. Обратитесь к финансовому оператору, чтобы открыть его.",
  "finance.serviceEntry.chooseService": "Выберите прайс-лист и услугу.",
  "finance.serviceEntry.dateQuantityRequired": "Укажите дату услуги и количество от 1 до 100.",
  "finance.serviceEntry.reason": "Примечание к подтверждению услуги",
  "finance.serviceEntry.reasonRequired": "Введите примечание длиной не менее 3 символов.",
  "finance.serviceEntry.preview": "Проверить начисление",
  "finance.serviceEntry.confirm": "Подтвердить услугу и начисление",
  "finance.serviceEntry.loading": "Расчёт начисления…",
  "finance.serviceEntry.saving": "Запись услуги…",
  "finance.serviceEntry.gross": "Начисление с налогом",
  "finance.serviceEntry.net": "Начисление без налога",
  "finance.serviceEntry.tax": "Включённый налог",
  "finance.serviceEntry.unsaved": "неподтверждённая услуга и начисление",
  "finance.serviceEntry.failed": "Не удалось записать услугу. Введённые данные сохранены.",
  "finance.serviceEntry.profileMissing": "Финансовый профиль клиники не настроен.",
  "finance.serviceEntry.periodClosed": "Финансовый период даты услуги закрыт.",
  "finance.serviceEntry.currencyMismatch": "В выбранных прайс-листе и счёте используются разные определения валюты.",
  "finance.serviceEntry.changed": "Запись, счёт или публикация цен изменились. Перечитайте данные перед подтверждением.",
  "finance.serviceEntry.forbidden": "У вас нет прав на запись клинических услуг и начислений.",
  "finance.serviceEntry.unavailable": "Выбранный источник услуги или счёт недоступен.",
  "finance.serviceEntry.contextFailed": "Не удалось загрузить данные для записи услуги.",
  "finance.serviceEntry.serviceUnavailable": "Этой услуги нет в выбранном прайс-листе.",
  "finance.serviceEntry.reload": "Перечитать данные",
  "finance.serviceEntry.reloadFailed": "Не удалось перечитать данные. Введённые значения сохранены.",
  "finance.serviceEntry.reloaded": "Актуальные данные загружены. Повторно выберите и подтвердите услугу.",
  "finance.prepaidEntry.mode": "Оплата услуги",
  "finance.prepaidEntry.selfPay": "Новое начисление",
  "finance.prepaidEntry.prepaid": "Предоплаченные услуги",
  "finance.prepaidEntry.title": "Оказание предоплаченных услуг",
  "finance.prepaidEntry.available": "Доступные купленные единицы",
  "finance.prepaidEntry.chooseRange": "Выберите диапазон покупки",
  "finance.prepaidEntry.choice": "{service} · покупка {date} · {range} · {price} за единицу",
  "finance.prepaidEntry.range": "Единицы {first}–{last}",
  "finance.prepaidEntry.first": "Номер первой исходной единицы",
  "finance.prepaidEntry.add": "Добавить выбранные единицы",
  "finance.prepaidEntry.remove": "Убрать выбранный диапазон",
  "finance.prepaidEntry.more": "Ещё доступные единицы",
  "finance.prepaidEntry.empty": "У пациента нет доступных предоплаченных единиц.",
  "finance.prepaidEntry.chooseUnits": "Выберите исходные купленные единицы для этой услуги.",
  "finance.prepaidEntry.addPending": "Добавьте выбранные единицы или очистите выбор диапазона.",
  "finance.prepaidEntry.preview": "Проверить использование предоплаты",
  "finance.prepaidEntry.confirm": "Подтвердить предоплаченную услугу",
  "finance.prepaidEntry.loading": "Проверка купленных единиц…",
  "finance.prepaidEntry.gross": "Используемая стоимость покупки",
  "finance.prepaidEntry.net": "Стоимость покупки без налога",
  "finance.prepaidEntry.unsaved": "неподтверждённая предоплаченная услуга",
  "finance.prepaidEntry.failed": "Не удалось записать предоплаченную услугу. Введённые данные сохранены.",
  "finance.prepaidEntry.readFailed": "Не удалось загрузить доступные купленные единицы.",
  "finance.prepaidEntry.periodClosed": "Необходимый финансовый период закрыт.",
  "finance.prepaidEntry.currencyMismatch": "Определение валюты покупки отличается от финансового профиля клиники.",
  "finance.prepaidEntry.unitsUnavailable": "Выбранные единицы уже использованы или возвращены. Обновите доступные единицы.",
  "finance.prepaidEntry.notActive": "Покупка не оплачена полностью или не активна.",
  "finance.prepaidEntry.changed": "Запись, покупка или исходный счёт изменились. Обновите данные перед подтверждением.",
  "finance.prepaidEntry.forbidden": "Нет прав на запись клинических услуг с использованием предоплаты.",
  "finance.prepaidEntry.unavailable": "Выбранная покупка или клиническая запись недоступна.",
  "finance.prepaidCorrection.title": "Исправить предоплаченную услугу",
  "finance.prepaidCorrection.gross": "Стоимость, возвращаемая в покупку",
  "finance.prepaidCorrection.net": "Возвращаемая стоимость без налога",
  "finance.prepaidCorrection.restored": "Восстанавливаемые единицы покупки",
  "finance.prepaidCorrection.keepOnRecord": "Подтверждаю оставшиеся услуги в текущем протоколе:",
  "finance.prepaidCorrection.confirmRetention": "Подтвердите текущий протокол для оставшихся услуг.",
  "finance.prepaidCorrection.currentRecordRequired": "Для сохранения услуг нужен текущий основной протокол. Для полной отмены новый протокол не требуется.",
  "finance.prepaidCorrection.noPayout": "Отменённые единицы станут доступны в исходной покупке. Выплата денег не производится.",
  "finance.prepaidCorrection.sourceChanged": "Исходная услуга, покупка или счёт изменились. Обновите данные перед подтверждением.",
  "finance.prepaidCorrection.unsaved": "неподтверждённое исправление предоплаченной услуги",
  "finance.participants.name": "Имя или название",
  "finance.participants.person": "Персона",
  "finance.participants.organization": "Организация",
  "finance.participants.openIdentity": "Открыть карточку",
  "finance.participants.accounts": "Лицевые счета",
  "finance.participants.noAccounts": "Лицевых счетов пока нет.",
  "finance.participants.openAccount": "Открыть счёт",
  "finance.participants.account": "Счёт в {currency}",
  "finance.participants.positionFailed": "Не удалось загрузить остатки счёта.",
  "finance.participants.add": "Добавить участника расчётов",
  "finance.participants.unsaved": "несохранённый участник расчётов",
  "finance.participants.newPerson": "Зарегистрировать новую персону",
  "finance.participants.newOrganization": "Зарегистрировать новую организацию",
  "finance.participants.back": "К участникам расчётов",
  "finance.participants.openPatient": "Открыть карточку пациента",
  "finance.participants.staffIdentity": "Данные сотрудника; для изменения нужны соответствующие права.",
  "finance.participants.identityRestricted": "Личные данные изменяются через существующую роль с соответствующими правами.",
  "finance.permissions.title": "Разрешено оплачивать за",
  "finance.permissions.loading": "Загрузка разрешения на оплату",
  "finance.permissions.failed": "Не удалось загрузить разрешения на оплату.",
  "finance.permissions.empty": "Разрешений на оплату за других пациентов нет.",
  "finance.permissions.allowed": "Владелец счёта разрешил оплату за этого пациента.",
  "finance.permissions.required": "Для списания нужно разрешение владельца счёта на оплату за этого пациента.",
  "finance.permissions.manage": "Открыть разрешения счёта",
  "finance.permissions.add": "Оформить разрешение владельца",
  "finance.permissions.more": "Показать ещё",
  "finance.permissions.patientUnavailable": "Имя пациента недоступно",
  "finance.permissions.active": "Действует",
  "finance.permissions.revoked": "Отозвано",
  "finance.permissions.revoke": "Отозвать разрешение",
  "finance.permissions.reason": "Причина и основание",
  "finance.permissions.document": "Документ-основание {number}",
  "finance.permissions.documentFailed": "Не удалось прочитать подтверждающие документы.",
  "finance.permissions.documents": "Подтверждающие документы (необязательно)",
  "finance.permissions.upload": "Приложить подписанное заявление или подтверждающие файлы",
  "finance.permissions.ownerStatement": "Зафиксируйте явное разрешение владельца счёта оплачивать за выбранного пациента. Родство само по себе не является разрешением.",
  "finance.permissions.patient": "Пациент, за которого разрешена оплата",
  "finance.permissions.save": "Сохранить разрешение",
  "finance.permissions.unsaved": "несохранённое разрешение на оплату",
  "finance.permissions.discard": "Отбросить несохранённые сведения? Загруженные документы останутся в файлах персоны.",
  "finance.settlement.sourceOwner": "Списать со счёта",
  "finance.settlement.sourceAccount": "Счёт списания",
  "finance.participants.patientAccount": "Счёт пациента",
  "finance.permissions.exists": "Для этого пациента уже есть действующее разрешение на оплату.",
  "finance.permissions.accountInactive": "Счёт списания не активен.",
  "finance.permissions.unavailable": "Счёт, пациент или разрешение больше недоступны.",
};
